<template>
  <div class="product-bubble-wrapper">
    <div v-show="showBubble" class="product-bubble thead-bubble product-label-thead-bubble" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()" v-html="bubbleText" />
    <div>
      商品ラベル貼付
      <i class="fa fa-question-circle thead-bubble-icon"
        @mouseover="handleMouseOver()"
        @mouseleave="handleMouseLeave()"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showBubble: false
    }
  },
  computed: {
    bubbleText () {
      return `倉庫へ納品する際に、商品ラベルの貼付けを自分で貼付けるか、<br/>セルモンに貼付けを依頼するかを選択してください。<br/>※セルモンに貼付けを依頼する場合は、オプション費用がかかります。`
    }
  },
  methods: {
    handleMouseOver () {
      this.showBubble = true
    },
    handleMouseLeave () {
      this.showBubble = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/GoodsLabelThead.vue